import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm } from "soft_digi";
import { OFFICE_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";

import { showAlertAutoClose } from "../../services/notifyService";

import {
  admin_states_select,
  user_get_select,
} from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";


interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  state: Yup.object().required("State is required"),
  office_city: Yup.string()
    .required("City is required")
    .max(25, "City must be at most 25 characters"),
  pin_code: Yup.string()
    .required("Pin Code is required")
    .matches(/^\d{6}$/, "Pin Code must be exactly 6 digits"),
  gst_no: Yup.string()
    .required("GST No. is required")
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST No."
    ),
    pan_no: Yup.string()
    .matches(
      /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/,
      "PAN number must follow the format TOUPP5464A"
    )
    .required("PAN number is required"),
  cin_no: Yup.string()
    .required("CIN No. is required")
    .max(25, "CIN No. must be at most 25 characters"),
  sgst: Yup.number()
    .required("SGST is required")
    .min(0, "SGST must be at least 0")
    .max(100, "SGST must be at most 100"),
  cgst: Yup.number()
    .required("CGST is required")
    .min(0, "CGST must be at least 0")
    .max(100, "CGST must be at most 100"),
  igst: Yup.number()
    .required("IGST is required")
    .min(0, "IGST must be at least 0")
    .max(100, "IGST must be at most 100"),
  address_one: Yup.string()
    .required("Address is required")
    .max(255, "Address must be at most 255 characters"),
  role: Yup.array()
    .required("City In-charge is required")
    .min(1, "At least one role must be selected"),
});
const OfficesForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const [allRole, setAllRole] = useState([]);

  const { closeModal } = useSiteContext();
  const [states, setStates] = useState([]);
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: dataIn,
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    admin_states_select((data: any) => setStates(data));
    user_get_select((data: any) => setAllRole(data));
  }, []);

  const onSubmit = (data: any) => {
    let url = OFFICE_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      data["id"] = dataIn.ID;
      url = OFFICE_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      showAlertAutoClose("Data Saved Successfully", "success");
      loadTableData();
      closeModal();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const formElements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 4,
      name: "state",
      element: {
        label: "State",
        isRequired: true,
        options: states,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "office_city",
      element: {
        label: "City",
        // placeHolder: "City",
        isRequired: true,
        max: 25,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "pin_code",
      element: {
        label: "Pin Code",
        // placeHolder: "City",
        isRequired: true,
        // inputProps: { isFocussed: true },
        type: "number",
        max: 6,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "TEXT_BOX",
      width: 4,
      name: "gst_no",
      element: {
        label: "GST No.",
        // placeHolder: "City",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",

        //  pattern: "[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$",

        max: 15,
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "pan_no",
      element: {
        label: "PAN No.",
        isRequired: true,
        inputType: "BORDER_LABEL",
        // pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
        max: 15,
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "cin_no",
      element: {
        label: "CIN No",
        isRequired: true,
        max: 25,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "TEXT_BOX",
      width: 4,
      name: "sgst",
      element: {
        label: "SGST (%)",
        // placeHolder: "City",
        isRequired: true,
        max: 3,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "cgst",
      element: {
        label: "CGST (%)",
        // placeHolder: "City",
        isRequired: true,
        // inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
        max: 3,
      },
    },
    {
      type: "TEXT_BOX",
      width: 4,
      name: "igst",
      element: {
        label: "IGST (%)",
        // placeHolder: "City",
        isRequired: true,
        // inputProps: { isFocussed: true },
        // pattern:  ALLOW_ALPHABET_SPACE ,

        inputType: "BORDER_LABEL",
        max: 3,
      },
    },

    {
      type: "TEXTAREA",
      width: 12,
      name: "address_one",
      element: {
        label: "Address",
        isRequired: true,
        max: 255,
        rows: 2,

        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "role",
      element: {
        label: "City In-charge",
        isRequired: true,
        options: allRole,
        isMulti: true,
        //  validations: hubFormValidations.role,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "LABEL",
      width: 8,
      name: "label",
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-third-button"],
        label: "Close",
        onClick: closeModal,
      },
    },
    {
      type: "BUTTON",
      width: 2,
      name: "submit_button",
      // class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-efl-input">
        {/* <SmartSoftForm
          formData={formData}
          setFormData={handleInputChange}
          elements={formElements}
          formSubmit={formSubmit}
          handleErrorChange={handleErrorChange}
        /> */}
        <SdsForm elements={formElements} errors={errors} control={control} />
        {/* <div className="has-text-right">
          <SmartSoftButton
            label="Cancel"
            classList={["button", "smart-third-button", "mt-4 mr-4"]}
            onClick={closeModal}
          />
          <SmartSoftButton
            label={dataIn.ID ? "Update" : "Submit"}
            rightIcon="fa fa-arrow-right"
            classList={["button ", "mt-4", "smart-action-button"]}
            onClick={handleSubmit(Onsubmit)}
          />
        </div> */}
      </div>
    </>
  );
};

export default OfficesForm;
